import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
  Button,
  CardFooter,
} from "reactstrap"
import { useTranslation } from "react-i18next"
import Lottie from "lottie-react"
import Footer from "./footer"
//redux
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

// action
import {
  userForgetPassword,
  confirmation,
  userForgetPasswordSuccess,
} from "../../store/actions"

// import images
import profile from "../../assets/images/profile-img.png"
import loadingAD from "../../assets/json/load-fragmented-square.json"
import { isValidPassword } from "../../config/validate"

const ForgetPasswordPage = props => {
  const [logo, setLogo] = useState()
  const { t } = useTranslation()
  document.title =
    t("messageForgetPassword:recover") + " | " + t("global:title")

  const dispatch = useDispatch()

  useEffect(() => {
    document.getElementById("body").className = "ForgetPasswordPage"

    import(
      "assets/images/" + process.env.REACT_APP_STYLE_TEMPLATE + "/logo.svg"
    ).then(setLogo)
    import(
      "assets/css/" +
        process.env.REACT_APP_STYLE_TEMPLATE +
        "/forgetPassword.css"
    )
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required(
        t("forgetPassword:messageError") + t("forgetPassword:email")
      ),
    }),
    onSubmit: values => {
      dispatch(userForgetPassword(values, props.history))
    },
  })

  const validationConfirmation = useFormik({
    enableReinitialize: true,
    initialValues: {
      confirmation: "",
      password: "",
      passwordConfirmation: "",
    },
    validationSchema: Yup.object({
      confirmation: Yup.string().required(
        t("forgetPassword:messageError") + t("forgetPassword:codeConfirmation")
      ),
      password: Yup.string()
        .required(
          t("forgetPassword:messageError") + t("forgetPassword:password")
        )
        .test(
          "is-password-true",
          t("registerUser:messageErrorPassword"),
          function (value) {
            return isValidPassword(value)
          }
        ),
      passwordConfirmation: Yup.string()
        .required(
          t("forgetPassword:messageError") +
            t("forgetPassword:passwordConfirmation")
        )
        .test(
          "is-password",
          t("registerUser:messageErrorPasswordConfirmation"),
          function (value) {
            return value === this.parent.password
          }
        ),
    }),
    onSubmit: values => {
      dispatch(
        confirmation(
          { ...values, email: validation.values.email },
          props.history
        )
      )
    },
  })

  const { forgetError, forgetSuccessMsg, loading } = useSelector(state => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
    loading: state.ForgetPassword.loading,
  }))

  const onBack = () => {
    dispatch(userForgetPasswordSuccess(null))
    props.history.push("/login")
  }

  const renderConfirmation = () => {
    return (
      <Form
        className="form-horizontal"
        onSubmit={e => {
          e.preventDefault()
          validationConfirmation.handleSubmit()
          return false
        }}
      >
        {forgetError && forgetError ? (
          <Alert color="danger">{forgetError}</Alert>
        ) : null}
        <div className="mb-3">
          <Label className="form-label">
            {t("forgetPassword:codeConfirmation")}
          </Label>
          <Input
            id="confirmation"
            name="confirmation"
            className="form-control"
            type="text"
            onChange={validationConfirmation.handleChange}
            onBlur={validationConfirmation.handleBlur}
            value={validationConfirmation.values.confirmation || ""}
            invalid={
              validationConfirmation.touched.confirmation &&
              validationConfirmation.errors.confirmation
                ? true
                : false
            }
          />
          {validationConfirmation.touched.confirmation &&
          validationConfirmation.errors.confirmation ? (
            <FormFeedback type="invalid">
              {validationConfirmation.errors.confirmation}
            </FormFeedback>
          ) : null}
        </div>
        <div className="mb-3">
          <Label className="form-label">{t("forgetPassword:password")}</Label>
          <Input
            id="password"
            name="password"
            className="form-control"
            type="password"
            onChange={validationConfirmation.handleChange}
            onBlur={validationConfirmation.handleBlur}
            value={validationConfirmation.values.password || ""}
            invalid={
              validationConfirmation.touched.password &&
              validationConfirmation.errors.password
                ? true
                : false
            }
          />
          {validationConfirmation.touched.password &&
          validationConfirmation.errors.password ? (
            <FormFeedback type="invalid">
              {validationConfirmation.errors.password}
            </FormFeedback>
          ) : null}
        </div>
        <div className="mb-3">
          <Label className="form-label">
            {t("forgetPassword:passwordConfirmation")}
          </Label>
          <Input
            id="passwordConfirmation"
            name="passwordConfirmation"
            className="form-control"
            type="password"
            onChange={validationConfirmation.handleChange}
            onBlur={validationConfirmation.handleBlur}
            value={validationConfirmation.values.passwordConfirmation || ""}
            invalid={
              validationConfirmation.touched.passwordConfirmation &&
              validationConfirmation.errors.passwordConfirmation
                ? true
                : false
            }
          />
          {validationConfirmation.touched.passwordConfirmation &&
          validationConfirmation.errors.passwordConfirmation ? (
            <FormFeedback type="invalid">
              {validationConfirmation.errors.passwordConfirmation}
            </FormFeedback>
          ) : null}
        </div>
        <div>
          <Label className="form-label label-notification">
            {t("messageRegister:msmPassword")}
          </Label>
        </div>
        <div className="mt-4  text-end">
          <Button className="mr-4" color="primary" onClick={onBack}>
            {t("forgetPassword:back")}
          </Button>{" "}
          <Button className="mr-4" color="primary" type="submit">
            {t("forgetPassword:save")}
          </Button>
        </div>
      </Form>
    )
  }

  return loading ? (
    <div>
      <Lottie animationData={loadingAD} />
    </div>
  ) : (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">
                          {t("messageForgetPassword:recover")}
                        </h5>
                        <p>{t("messageForgetPassword:enter")}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-info">
                          <img
                            src={logo?.default}
                            alt=""
                            className="rounded-circle"
                            height="64"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}

                    {!forgetSuccessMsg ? (
                      <Form
                        className="form-horizontal"
                        onSubmit={e => {
                          e.preventDefault()
                          validation.handleSubmit()
                          return false
                        }}
                      >
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("forgetPassword:email")}
                          </Label>
                          <Input
                            name="email"
                            className="form-control"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <Row className="mb-3">
                          <Col className="text-end">
                            <button
                              className="btn btn-primary w-md "
                              type="submit"
                            >
                               <i className="mdi mdi-send-circle-outline me-1" />
                              {t("forgetPassword:sendCode")}
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    ) : (
                      renderConfirmation()
                    )}
                  </div>
                </CardBody>
                <CardFooter>
                  <div className=" text-center">
                    <p>
                      {t("messageRegister:alreadyRegistered")}{" "}
                      <Link
                        to="/login"
                        className="font-weight-medium text-primary"
                      >
                        {" "}
                        {t("authentication:login")}
                      </Link>{" "}
                    </p>
                    <Footer />
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
